import React, { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import { api } from "./api";

const SigCreate = () => {
  const sigCanvas = useRef({});
  const canvasWrapper = useRef(null);
  const navigate = useNavigate();
  const { state } = useLocation();
  const requestNumber = state?.requestNumber || "";
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const displayMessage = (msg) => {
    setShowMessage(false); // reset first
    setTimeout(() => {
      setMessage(msg);
      setShowMessage(true);
    }, 50);
  };
  const [canvasWidth, setCanvasWidth] = useState(900);
  const [canvasHeight] = useState(300); // fixed height

  useEffect(() => {
    const handleResize = () => {
      const width = canvasWrapper.current?.offsetWidth || 900;
      setCanvasWidth(width);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClear = () => sigCanvas.current.clear();

  const handleSubmit = async () => {
    if (sigCanvas.current.isEmpty()) {
      displayMessage("Please provide a signature.");
      return;
    }

    const signatureData = sigCanvas.current
      .getTrimmedCanvas()
      .toDataURL("image/png");

    try {
      setLoading(true);
      const response = await api.post("/save-signature", {
        requestNumber,
        signatureData,
      });
      

      if (response.status === 200) {
        displayMessage("Signature saved successfully!");
        setTimeout(() => navigate("/sig"), 3000);
      } else {
        displayMessage("Failed to save signature.");
      }
      
    } catch (error) {
      console.error("Submission error:", error);
      displayMessage("An error occurred while saving the signature.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Fixed Top Buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "5px",
          width: "100%",
          margin: 0,
          padding: 0,
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 1000,
          backgroundColor: "#f9fafb",
        }}
      >
        <button
          onClick={handleClear}
          className="blue-button"
          style={{
            backgroundColor: "#6b7280",
            flex: 1,
            padding: "4px 0",
            fontSize: "13px",
          }}
        >
          CLEAR
        </button>
        <button
          onClick={() => navigate("/sig")}
          className="blue-button"
          style={{
            backgroundColor: "#6b7280",
            flex: 1,
            padding: "4px 0",
            fontSize: "13px",
          }}
        >
          BACK
        </button>
        <button
          onClick={handleSubmit}
          className="blue-button"
          disabled={loading}
          style={{ flex: 1, padding: "4px 0", fontSize: "13px" }}
        >
          {loading ? "Submitting..." : `SUBMIT ${requestNumber}`}
        </button>
      </div>

      {/* Page Content */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "10px",
          paddingTop: "50px", // leave space for fixed top buttons
          minHeight: "100vh",
          boxSizing: "border-box",
          backgroundColor: "#f9fafb",
          overflowY: "auto",
        }}
      >
        {showMessage && (
          <div className="alert-box" style={{ marginBottom: "10px" }}>
            {message}
          </div>
        )}

        <div
          ref={canvasWrapper}
          style={{
            width: "100%",
            marginBottom: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <SignatureCanvas
            penColor="black"
            canvasProps={{
              width: canvasWidth,
              height: canvasHeight,
              className: "sigCanvas",
              style: {
                border: "2px solid #000",
                borderRadius: "8px",
                backgroundColor: "#fff",
              },
            }}
            ref={sigCanvas}
          />
        </div>
      </div>
    </>
  );
};

export default SigCreate;
